/* global axios */
import ApiClient from '../ApiClient';

class NexceoBrandingAPI extends ApiClient {
  constructor() {
    super('nexceo/branding', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(payload) {
    return axios.put(this.url, payload);
  }

  upload(assetType, file) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('asset_type', assetType);
    return axios.post(`${this.url}/upload`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeAsset(assetType) {
    return axios.delete(`${this.url}/assets/${assetType}`);
  }
}

export default new NexceoBrandingAPI();
